import {CoreRoute} from '@tech/intranet-core-protocol';
import {UserRoles} from "@shared/enums/user-roles.enum";

export const CoreRoutes: CoreRoute[] = [
  {    
    icon: 'translate',
    name: 'coreRoutes.deeplTranslator',    
    neededRole: UserRoles.productionUser,
    url: 'deeplTranslator',  
  }
];
